// eslint-disable-next-line import/prefer-default-export
export const contactMethods = {
  email: "Email",
  phone: "Teléfono",
};
